import styled from "styled-components"

export const FormStarWrapper = styled.div`
.FormStarRatting{
    padding:  12px 0;
    display: flex;
    align-items: center;
    &_list{
        display: flex;
        align-items: center;
        list-style: none;
        margin-right: 22px;
        margin-left: 0;
        padding: 0;
        &_item{
            margin: 0 8px;
            &_icon{
                color: #e2c1c1;
                cursor:  pointer;
               
            }
        }
    }
}
`
